module.exports = "/_next/static/images/BreakdownSilosBetweenTeams@2x-878681df21bc10e154cf902004207e4d.webp";